/*  Colega Link · Cuadro de datos bancarios del mediador (SOLO admin)
    Se renderiza en:
    - MediationRequestDetail.js (vista de detalle) al lado del botón "Aprobar Liberación de Pago"
    - AdminConsolaMediaciones.js (lista) al lado del botón "Autorizar Pago"
    Los datos SIEMPRE se muestran mientras el objeto exista (incluyendo estado
    'completada') para preservar el registro histórico de a quién se le pagó.
    La visibilidad depende exclusivamente del backend: sólo se envían al rol admin.
*/
import { useState } from "react";
import { Lock, Check } from "lucide-react";

export default function AdminMediatorBankCard({ bank, compact = false }) {
  const [copied, setCopied] = useState(false);
  if (!bank) return null;
  const plain = [
    `Beneficiario: ${bank.holder || "—"}`,
    `RUT: ${bank.rut || "—"}`,
    `Banco: ${bank.bank_name || "—"}`,
    `${bank.account_type || "Cuenta"}: ${bank.account_number || "—"}`,
    `Email: ${bank.email || "—"}`,
  ].join("\n");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(plain);
      setCopied(true); setTimeout(() => setCopied(false), 2200);
    } catch { /* noop */ }
  };
  return (
    <div className={`rounded-lg border border-cyan-400/30 bg-cyan-400/[0.05] ${compact ? "p-3" : "p-4"}`} data-testid="admin-mediator-bank-card">
      <div className="flex items-center justify-between gap-2">
        <div className="label-eyebrow text-cyan-300 inline-flex items-center gap-1.5">
          <Lock size={11}/> Datos bancarios del mediador · uso admin
        </div>
        {bank.complete ? (
          <span className="pill text-[9px] border-emerald-400/40 bg-emerald-400/10 text-emerald-300">Completos</span>
        ) : (
          <span className="pill text-[9px] border-amber-400/40 bg-amber-400/10 text-amber-300">Incompletos</span>
        )}
      </div>
      {!bank.complete && (
        <div className={`mt-2 text-[11px] text-amber-200`}>
          El mediador aún no completó todos sus datos bancarios. Contáctalo antes de transferir.
        </div>
      )}
      <div className={`mt-3 space-y-1 ${compact ? "text-[11px]" : "text-xs"} font-mono`}>
        <BankLine label="Beneficiario" value={bank.holder}/>
        <BankLine label="RUT" value={bank.rut}/>
        <BankLine label="Banco" value={bank.bank_name}/>
        <BankLine label={bank.account_type || "Cuenta"} value={bank.account_number}/>
        <BankLine label="Email" value={bank.email}/>
        {bank.phone && <BankLine label="Teléfono" value={bank.phone}/>}
      </div>
      <button type="button" onClick={copy} className="mt-3 w-full px-3 py-1.5 rounded-md border border-white/15 text-xs hover:bg-white/5 inline-flex items-center justify-center gap-2" data-testid="admin-bank-copy">
        {copied ? <><Check size={12} className="text-emerald-300"/> Copiado al portapapeles</> : <>Copiar datos bancarios</>}
      </button>
      <p className="mt-2 text-[10px] text-muted-foreground text-center italic">Información privada. Sólo visible al administrador.</p>
    </div>
  );
}

function BankLine({ label, value }) {
  return (
    <div className="flex justify-between gap-3">
      <span className="text-muted-foreground">{label}:</span>
      <span className="text-foreground font-medium text-right break-all">{value || "—"}</span>
    </div>
  );
}
